import _implicitStylesheets from "./reviewsEmptyState.css";
import _implicitScopedStylesheets from "./reviewsEmptyState.scoped.css?scoped=true";
import _adsImage from "ads/image";
import _wdsButton from "wds/button";
import _listingWriteReview from "listing/writeReview";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<svg class="loading_image${0}"${"a0:width"}${"a0:height"} viewBox="0 0 26 26" fill="white" xmlns="http://www.w3.org/2000/svg"${2}><path fill-rule="evenodd" clip-rule="evenodd" d="M25 5C25 3.9 24.1 3 23 3H3C1.9 3 1 3.9 1 5V21C1 22.1 1.9 23 3 23H23C24.1 23 25 22.1 25 21V5ZM19.8 19H5.3C4.7 19 4.35 18.35 4.65 17.85L9.05 10.2C9.25 9.85 9.7 9.85 9.9 10.2L12.55 14.75C12.75 15.05 13.2 15.1 13.4 14.8L15.55 11.7C15.75 11.4 16.2 11.4 16.4 11.7L20.35 18C20.65 18.45 20.35 19 19.8 19ZM18.5 10C17.4 10 16.5 9.1 16.5 8C16.5 6.9 17.4 6 18.5 6C19.6 6 20.5 6.9 20.5 8C20.5 9.1 19.6 10 18.5 10Z"${3}/></svg>`;
const $fragment2 = parseFragment`<h3 type-style="display-4"${3}>${"t1"}</h3>`;
const $fragment3 = parseFragment`<p type-style="body-1"${3}>${"t1"}</p>`;
const stc0 = {
  classMap: {
    "container": true
  },
  key: 0
};
const stc1 = {
  slotAssignment: "loading",
  classMap: {
    "loading-image-container": true
  },
  key: 2
};
const stc2 = {
  "write-review-btn": true
};
const stc3 = {
  "data-testid": "write-review-button"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {sp: api_static_part, st: api_static_fragment, h: api_element, c: api_custom_element, d: api_dynamic_text, b: api_bind} = $api;
  const {_m0, _m1} = $ctx;
  return [api_element("div", stc0, [api_custom_element("ads-image", _adsImage, {
    props: {
      "src": $cmp.imageUrl,
      "width": $cmp.loadingImageWidth,
      "height": $cmp.loadingImageHeight,
      "alt": $cmp.labels.title
    },
    key: 1
  }, [api_element("div", stc1, [api_static_fragment($fragment1, 4, [api_static_part(0, {
    attrs: {
      "width": $cmp.loadingImageWidth,
      "height": $cmp.loadingImageHeight
    }
  }, null)])])]), api_static_fragment($fragment2, 6, [api_static_part(1, null, api_dynamic_text($cmp.labels.title))]), api_static_fragment($fragment3, 8, [api_static_part(1, null, api_dynamic_text($cmp.labels.description))]), !$cmp.filtersApplied ? api_custom_element("wds-button", _wdsButton, {
    classMap: stc2,
    attrs: stc3,
    props: {
      "size": "small",
      "label": $cmp.labels.writeBtn
    },
    key: 9,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleWriteReviewButtonClick))
    }
  }) : null, $cmp.showWriteReviewModal ? api_custom_element("listing-write-review", _listingWriteReview, {
    props: {
      "closedFocusTarget": $cmp.writeReviewButtonRef,
      "listingId": $cmp.listingId,
      "autoFocusOff": $cmp.shouldAutoFocusWriteReviewModal
    },
    key: 10,
    on: {
      "close": _m1 || ($ctx._m1 = api_bind($cmp.toggleWriteReviewModal))
    }
  }) : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-1jcg8lgsba4";
tmpl.legacyStylesheetToken = "undefined-_reviewsEmptyState";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
